
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';



import { AppComponent } from './paginas/app.component';
import { LoginComponent } from './login/login.component';


export const routes: Routes = [
    // {path: '', component: DashboardDemoComponent},


    { path: 'login', component: LoginComponent }




];

export const APP_ROUTES: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });
